<template>
  <div class="page-apply">
    <div class="content-wrapper">
      <div class="breadcrumb-wrapper" v-if="!isFromSpecialCertification">
        <h-breadcrumb separator=">">
          <h-breadcrumb-item href="/serviceProductAll"
            >组件集市</h-breadcrumb-item
          >
          <h-breadcrumb-item>收银台</h-breadcrumb-item>
        </h-breadcrumb>
      </div>
    </div>
    <div class="apply-form-wrapper">
      <h2 class="order-title">订单详情</h2>
      <ul class="confirm_purchase_service">
        <li class="confirm-table-title">
          <span class="span_1">订单编号</span>
          <span class="span_2">产品名称</span>
          <span class="span_3">交付方式</span
          ><span class="span_4">套餐参数</span>
          <span class="span_5">应支付金额</span>
        </li>
        <li class="confirm-table-body">
          <span class="span_1">{{ order_id }}</span>
          <span class="span_2" :title="order_info.service_name">{{ order_info.service_name }}</span
          ><span class="span_3" :title="order_info.alternation_name">{{ order_info.alternation_name }}</span>
          <span class="span_4" :title="order_info.set_meal_str">{{ order_info.set_meal_str }}</span>
         
          <span class="span_5 price" v-if="String(order_info.order_handle_status) == '1'"
            >待商务</span
          >
           <span class="span_5 price" v-else
            >{{ order_info.units == "人民币" ? "¥" : "HK$"
            }}{{ order_info.payment_amount }}</span
          >
        </li>
      </ul>
      <div>
        <h2 class="order-title">支付方式</h2>
        <div class="tabs-content">
          <div
            class="tab"
            v-for="(item, index) in tabs"
            :key="index"
            :class="{ active: item == currentTab }"
            @click="currentTab = item"
          >
            {{ item }}
          </div>
        </div>
        <div class="payment-content" v-show="currentTab == '在线支付'">
          <div class="flex">
            <div
              class="payment-box"
              v-for="item in paymentList"
              @click="currentPayMethod = item.account_type"
              :key="item.account_type"
              :class="{ active: currentPayMethod == item.account_type }"
            >
              <img
                v-if="item.account_type == 1"
                src="../../assets/service/pay_fs1.png"
                alt
              />
              <img
                v-if="item.account_type == 2"
                src="../../assets/service/pay_fs2.png"
                alt
              />
              <img
                v-if="item.account_type == 5"
                src="../../assets/service/pay_fs5.png"
                alt
              />
              <img
                v-if="item.account_type == 4"
                src="../../assets/service/pay_fs4.png"
                alt
              />

              <img
                v-if="item.account_type == 7"
                src="../../assets/service/pay_fs7.png"
                alt
              />
              <span class="checked-status"></span>
              <!-- <img :src="'../../assets/service/pay_fs'+item.account_type+'.png'" alt /> -->
            </div>
          </div>
        </div>
        <div class="payment-content" v-show="currentTab == '线下支付'">
          <div>
            <img
              :src="
                require('../../assets/service/' +
                  underlinePay.bank_abbreviation +
                  '.png')
              "
              v-if="
                ['China_citic_bank', 'ICBC', 'CMB'].indexOf(
                  underlinePay.bank_abbreviation
                ) != -1
              "
              style="height:50px;margin-right:32px"
            />
            <span class="mr-30">单位名称：{{ underlinePay.unit_name }}</span>
            <span class="mr-30">开户银行：{{ underlinePay.opening_bank }}</span>
            <span class="mr-30">银行账号：{{ underlinePay.pay_account }}</span>
          </div>
          <div class="account-tip">
            <span class="m-icon-info"></span>
            温馨提示：为了不耽误您的使用服务，转账成功后请及时填写银行回执信息。
          </div>
          <div>
            <h-form
              ref="formItem"
              :model="formItem"
              :label-width="86"
              errorFocus
              cols="1"
              label-position="right"
              :rules="bindFormRule"
            >
              <h-form-item
                label="付款银行："
                required
                style="margin-bottom:12px;"
                prop="payment_bank"
              >
                <h-input
                  style="width:357px;"
                  v-model="formItem.payment_bank"
                  placeholder="请填写"
                  :disabled="disabled"
                  :maxlength="100"
                ></h-input>
              </h-form-item>
              <h-form-item
                label="付款账号："
                required
                style="margin-bottom:12px;"
                prop="payment_account"
              >
                <h-input
                  style="width:357px;"
                  v-model="formItem.payment_account"
                  placeholder="请填写"
                  :disabled="disabled"
                  :maxlength="100"
                ></h-input>
              </h-form-item>
              <h-form-item
                label="付款金额："
                style="margin-bottom:12px;"
                prop="pay_amount"
                required
              >
                <h-input
                  style="width:357px;"
                  v-model="formItem.pay_amount"
                  placeholder="请输入"
                  :disabled="disabled"
                  :maxlength="12"
                  @on-blur="handleAmountChange"
                ></h-input>
              </h-form-item>
              <h-form-item
                label="回执单号："
                required
                style="margin-bottom:8px;"
                prop="bankreceipt_serialno"
              >
                <h-input
                  style="width:357px;"
                  v-model="formItem.bankreceipt_serialno"
                  placeholder="请填写"
                  :disabled="disabled"
                  :maxlength="100"
                ></h-input>
              </h-form-item>
            </h-form>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_box" id="footer_box">
      <div class="foot-content">
        <div class="foot-left">
       
          <div >
               <span class="label">
            应支付金额：
          </span>
            <span class="price" v-if="String(order_info.order_handle_status) != '1'"><span
              class="unit"
              >{{ order_info.units == "人民币" ? "￥" : "HK$" }}</span
            >{{ order_info.payment_amount }} </span>
            <span class="discount"
              v-if="order_info.business_model == '1'">共减 ¥
              {{ order_info.price - order_info.payment_amount || 0 }}</span
            >
          </div>
          <div v-if="String(order_info.order_handle_status) == '1'">
            <span class="yellow">待商务</span>
          </div>
        </div>
        <div v-if="String(order_info.order_handle_status) == '2'">
          <!-- <h-button class="back-btn" type="ghost" @click="back">返回</h-button> -->
          <h-button
            v-if="currentTab == '在线支付'"
            type="primary"
            class="confirm-btn ml-10"
            @click="confirmPay();setGio('在线支付')"
            >确认支付</h-button
          >
          <h-button
            v-if="currentTab == '线下支付' && !formItem.serial_no"
            type="primary"
            class="confirm-btn ml-10"
            @click="submitOffline();setGio('线下支付')"
            >确认提交</h-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  detail,
  getOrderPaymentType,
  payOrderInner,
  queryMyOrderDetailInner,
  getPaymentResultInner,
  submitOfflineReceipt,
  queryOfflineReceipt
} from "@/api/service.js";
import CreateForm from "@/views/frontViews/components/createForm";
import _ from "lodash";
import axios from "axios";
import { deepClone } from "../../utils";
export default {
  name: "confirmOrder",
  components: {
    CreateForm
  },
  filters: {
    fiMoney(v) {
      let s = Number(v);
      if (isNaN(s)) {
        return "-";
      } else {
        return s.toFixed(2);
      }
    }
  },
  data() {
    const _this = this;
    function priceRule(rule, data, callback) {
      const ruleStr = /^(([1-9]\d{0,9})|0)(\.\d{1,2})?$/;
      if (data === "") {
        callback(new Error("价格必填"));
      } else if (!ruleStr.test(data)) {
        callback(new Error("请输入正确的格式"));
      } else {
        callback();
      }
    }
    return {
      bindFormRule: {
        pay_amount: [
          {
            validator: priceRule,
            trigger: "blur"
          }
        ]
      },
      currentPayMethod: "",
      currentTab: "在线支付",
      tabs: ["线下支付"],
      formItem: {
        payment_bank: "",
        payment_account: "",
        pay_amount: "",
        bankreceipt_serialno: "",
        serial_no: ""
      },
      order_id: this.$route.query.order_id,
      isType: "", //交付方式类型
      service_info: {}, //服务详情
      order_info: {},
      // chargeInfo: {}, //套餐详情
      service_id: this.$route.params.id,
      // charge_id: this.$route.params.cid,
      currentSelectCoupon: {},
      // selectCoupon: {},
      // clauseShow: false,
      // extraList: [],
      // formItemE: {},
      paymentList: [],
      underlinePay: {
        unit_name: "恒生电子股份有限公司",
        bank_abbreviation: "ICBC",
        opening_bank: "工行杭州羊坝头支行",
        pay_account: "1202020109006738151"
      },
      isFromSpecialCertification: false // 是否从课堂专项认证跳转过来
    };
  },
  computed: {
    disabled() {
      return !!(this.formItem && this.formItem.serial_no);
    }
  },
  created() {
    let that = this;
    this.getMyOrderDetailInner();
    detail(this.service_id).then(res => {
      that.isType = res.alternation_id;
      that.service_info = res;
      
      this.getOfflineReceipt();
      this.getMyOrderDetailInner();
      // this.getPaymentResult();
      getOrderPaymentType({
        service_id: this.service_id
      }).then(res => {
        this.paymentList = res.filter(item => {
          if (item.account_type == 3) {
            this.underlinePay = item;
            // this.tabs.push("线下支付");
            return false;
          } else if (item.account_type == 4) {
            this.currentPayMethod = item.account_type;
            return true;
          } else {
            return true;
          }
        });
        if (this.paymentList && this.paymentList.length) {
          this.tabs.unshift("在线支付");
          this.currentTab = "在线支付";
        } else {
          this.currentTab = "线下支付";
        }
      });
    });
    /* 兼容课堂专项认证下单操作 */
    const { courseCertificationId } = this.$route.query
    this.isFromSpecialCertification = !!courseCertificationId
    /* 兼容课堂专项认证下单操作end */
  },
  methods: {
    setGio(name) {
      if(name==='在线支付'){
      
        name = this.currentPayMethod=='4'?'支付宝':'在线支付'+this.currentPayMethod
      }
      try {
        let submitType_var="";
        submitType_var = this.order_info.business_model=='1'?'订单':'商务洽谈';
        this.gioTrackEvent("UMod_clickSubmit", {
          submitType_var:submitType_var,
          mop_var:name,
          modOrderID_var: this.order_id,
          moduleId_var: this.service_id,
          moduleName_var: this.order_info&&this.order_info.service_name,
          moduleParm_var:this.order_info&&this.order_info.set_meal_str
        });
      } catch (e) {
        console.log(e);
      }
    },
    handleAmountChange() {
      let val = this.formItem.pay_amount;
      this.formItem.pay_amount = (String(val).match(
        /(0|[1-9]\d{0,8})(\.\d{0,2})?/
      ) || [""])[0];
    },
    getMyOrderDetailInner() {
      queryMyOrderDetailInner({
        order_id: this.order_id
      }).then(res => {
        this.order_info = res;
       this.order_info.set_meal_str =  this.buyAcitivty(res);
      });
    },
    getOfflineReceipt() {
      queryOfflineReceipt({
        order_id: this.order_id
      }).then(res => {
        if (res && res.length) {
          this.formItem = res[0];
        }
      });
    },
    submitOffline() {
      this.$refs.formItem.validate(valid => {
        if (valid) { 

          submitOfflineReceipt({
            ...this.formItem,
            order_id: this.order_id
          }).then(res => {
            if (res) {
              this.$hMessage.success("回执信息提交成功！");
              // this.getOfflineReceipt();
              window.location.href = "/cloud-console/trade/myOrder";
            }
          });
        }
      });
    },
    getPaymentResult() {
      getPaymentResultInner({
        order_id: this.order_id
      }).then(res => {
        //支付成功
        if (res.pay_status == 3) {
          // this.$router.push({
          //     path:
          //       "/openplat-front/service/serviceDetail/" +
          //       this.service_id +
          //       "/confirmOrder/" +
          //       this.charge_id +
          //       "/paySuccess?order_id=" +
          //       res.order_id
          //   });
          location.replace(
            "/openplat-front/service/serviceDetail/" +
              this.service_id +
              "/orderPaySuccess?order_id=" +
              res.order_id
          );
        }
      });
    },
    //确认支付
    confirmPay() {
      const payType = this.currentTab == "线下支付" ? 3 : this.currentPayMethod;
      let pickup_url =
        location.origin +
        `/openplat-front/service/serviceDetail/${this.service_id}/orderPaySuccess?order_id=${this.order_id}`;
      /* 兼容课堂专项认证下单操作 */
      const { courseCertificationId } = this.$route.query
      if (courseCertificationId) {
        pickup_url = `${location.origin}/openplat-front/speclalCerifificationDetail?id=${courseCertificationId}`// 本来是两个参数，但是地址后面用&符拼接多个参数的话会导致支付不成功，所以将两个参数拼接成一个使用
      }
      /* 兼容课堂专项认证下单操作end */

      payOrderInner({
        order_id: this.order_id,
        pay_type: payType,
        terminal_type: 0,
        pickup_url: pickup_url
      }).then(res => {
        if(res==undefined){
          return
        }
        if (res && res.view) {
          var newWin = window.open("", "_blank");
          newWin.document.write(res.view);
          // 关闭输出流
          newWin.document.close();
        } else  {
          let replaceUrl = "/openplat-front/service/serviceDetail/" +
              this.service_id +
              "/orderPaySuccess?order_id=" +
              this.order_id
          /* 兼容课堂专项认证下单操作 */
          if (courseCertificationId) {
            replaceUrl = `/openplat-front/speclalCerifificationDetail?id=${courseCertificationId}`// 本来是两个参数，但是地址后面用&符拼接多个参数的话会导致支付不成功，所以将两个参数拼接成一个使用
          }
          /* 兼容课堂专项认证下单操作end */
          //  this.
          location.replace(replaceUrl);
        }
      },(e)=>{
        this.$hMessage.error('支付失败')
        console.error(e)
      });
    },
    //待商务
    back() {
      history.back();
    },
    buyAcitivty(res) {
      let notInType =
        [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "10",
          "11",
          "12",
          "16"
        ].indexOf(res.alternation_id) == -1;
      let set_meal_str = "";
      if (res.suite_name && res.suite_name != "--") {
        set_meal_str += res.suite_name;
      }
      if (
        res.suite_name &&
        res.suite_name != "--" &&
        res.alternation_id != "7" &&
        !notInType
      ) {
        set_meal_str += "：";
      }
      let comboType = "",
        aid = res.alternation_id;
      let val =
        aid == "6"
          ? "人数"
          : aid == "8"
          ? "人次"
          : aid == "4"
          ? "账号数"
          : "次数";
      comboType = val;
      let showEnv = false;
      if (
        res.alternation_id == "1" ||
        res.alternation_id == "2" ||
        res.alternation_id == "3" ||
        res.alternation_id == "11"
      ) {
        showEnv = true;
        set_meal_str += res.environment_type == "2" ? "生产环境" : "测试环境";
        set_meal_str += " / ";
      }
      if (
        res.alternation_id != "12" &&
        res.alternation_id != "10" &&
        res.alternation_id != "7" &&
        res.alternation_id != "16" &&
        !notInType
      ) {
        set_meal_str += this.hanlderVal(res.invoke_times) + "" + comboType + " / ";
      }
      if (res.alternation_id != "7" && !notInType) {
        set_meal_str += this.hanlderVal(res.used_length) + "天";
      }
      if (res.peak_value && res.peak_value != -1 && showEnv) {
        set_meal_str += `，峰值：${res.peak_value}次/秒`;
      }
      return set_meal_str;
    },
    hanlderVal(val) {
      return val == 0 || val == -1 ? "不限" : val;
    }
  }
};
</script>
<style lang="scss" scoped>
.mr-30 {
  margin-right: 30px;
}
.page-apply {
  padding-bottom: 70px;
}
.content-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0 9px 0;
}
.apply-form-wrapper {
  width: 1200px;
  padding-bottom: 20px;
  background: #fff;
  margin: 0 auto;
  padding: 20px 20px 12px;
  .order-title {
    font-family: PingFangSC-Medium;
    // font-weight: bold;
    font-size: 20px;
    color: #333333;
    font-weight: 500;
  }
  .confirm_purchase_service {
    margin-bottom: 23px;
    .confirm-table-title {
      width: 100%;
      height: 65px;
      line-height: 65px;
      display: flex;
      flex-wrap: nowrap;
      background: #f7f8fa;
      border-radius: 4px;
      justify-content: space-between;
      padding: 0 28px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 500;
      margin-bottom: 0;
    }
    .confirm-table-body {
      width: 100%;
      height: 44px;
      line-height: 44px;
      display: flex;
      flex-wrap: nowrap;
      // border-bottom: 1px solid rgba(230, 230, 230, 1);
      justify-content: space-between;
      padding: 0 28px;
      font-size: 14px;
      color: #333333;
      span {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .span_1 {
      width: 219px;
    }
    .span_2 {
      width: 224px;
    }
    .span_3 {
      width: 215px;
    }
    .span_4 {
      width: 294px;
    }
    .span_5 {
      width: 152px;
    }
    .price {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      font-weight: 600;
    }
  }
  .app_box {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    background: #fff8ed;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .app_box_left {
      display: flex;
    }
    .m-icon-message {
      width: 20px;
      height: 20px;
      background: url(~@/assets/icons/message.svg) 0 0 no-repeat;
      display: inline-block;
      vertical-align: middle;
      background-size: contain;
    }
    .change {
      width: 42px;
      height: 20px;
      border: 1px solid rgba(59, 107, 250, 1);
      border-radius: 10px;
      font-size: 12px;
      color: #3b6bfa;
      text-align: center;
      margin-right: 2px;
    }
  }
  .coupons_box {
    display: flex;
    justify-content: end;
    margin-top: 12px;
    align-items: center;
    .coupons_select {
      width: 220px;
      margin-left: 8px;
    }
  }
  .agreement_box {
    margin-top: 40px;
  }
}
.coupon-content {
  // margin-top: 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .coupon-item {
    width: 351px;
    height: 92px;
    background: url(~@/assets/service/coupon-bg.png) 0 0 no-repeat;
    background-size: contain;
    padding: 14px 12px;
    color: #ff8800;
    font-size: 12px;
    margin-bottom: 16px;
    cursor: pointer;
    &.active {
      background: url(~@/assets/service/coupon-bg-active.png) 0 0 no-repeat;
      background-size: contain;
    }
    .unit {
      width: 14px;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ff8800;
      line-height: 20px;
      font-weight: 500;
    }
    .number {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #ff8800;
      line-height: 20px;
      font-weight: 500;
    }
    .type {
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ff8800;
      line-height: 20px;
      font-weight: 500;
    }
  }
}
// .h-modal-body{
//   padding: 49px ;
// }
.footer_box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  background: #ffffff;
  border-top: 1px solid #e6e6e6;
  z-index: 99;
  .foot-content {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .foot-left {
      display: flex;
    }
    .yellow {
      // height: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      letter-spacing: 0;
      font-weight: 600;
    }
    .unit {
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #ff8800;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 600;
      display: inline-block;
      margin-right: 4px;
    }
    .price {
      height: 28px;
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #ff8800;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 600;
      display: inline-block;
    }
    .discount {
      height: 17px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ff8800;
      letter-spacing: 0;
      font-weight: 400;
      display: block;
      text-align: right;
    }
  }
  .back-btn {
    width: 100px;
  }
  .confirm-btn {
    width: 100px;
  }
}
.select-key-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  .radio {
    width: 18px;
    height: 18px;
    display: inline-block;
    background: url(~@/assets/icons/radio.png) 0 0 no-repeat;
    &.active {
      background: url(~@/assets/icons/radio-active.png) 0 0 no-repeat;
      background-size: cover;
    }
  }
  .key-group {
    margin-left: 20px;
    width: 409px;
    height: 30px;
    padding: 5px 12px;
    background: #ffffff;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    display: inline-block;
    line-height: 20px;
    text-align: center;
    .key-name {
      width: 113px;
      display: inline-block;
      text-align: left;
    }
    .key {
      display: inline-block;
      vertical-align: top;
    }
  }
}
.m-icon-plus {
  width: 20px;
  height: 20px;
  display: inline-block;
  background: url(~@/assets/icons/add.png) 0 0 no-repeat;
  background-size: contain;
}
.add-key-btn {
  width: 409px;
  height: 32px;
  background: #3b6bfa;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  margin-top: 8px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
  font-weight: 400;
  margin-left: 38px;
  cursor: pointer;
}
.payment-content {
  width: 1160px;
  padding: 23px 28px 20px;
  border: 1px solid rgba(230, 230, 230, 1);
  border-radius: 0px 4px 4px 4px;
  margin-top: -1px;
}
.payment-box {
  width: 140px;
  height: 50px;
  border: 1px solid rgba(230, 230, 230, 1);
  border-radius: 4px;
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
  .checked-status {
    background: url(~@/assets/service/radio.png) 0 0 no-repeat;
    width: 18px;
    height: 18px;
    position: absolute;
    bottom: 4px;
    right: 4px;
  }
  &.active {
    border: 1px solid rgba(59, 107, 250, 1);
    .checked-status {
      width: 14px;
      height: 14px;
      background: url(~@/assets/service/radio_checked.png) 0 0 no-repeat;
    }
  }
}

.m-icon-info {
  width: 16px;
  height: 16px;
  background: url(~@/assets/icons/info.png) 0 0 no-repeat;
  display: inline-block;
  background-size: contain;
  margin-right: 8px;
}
.account-tip {
  height: 36px;
  background: #fff8ed;
  border-radius: 2px;
  padding: 8px 12px;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  line-height: 20px;
  font-weight: 400;
  display: inline-block;
  margin-bottom: 20px;
  margin-top: 23px;
      display: flex;
    align-items: center;
}
.tabs-content {
  display: flex;

  .tab {
    width: 126px;
    margin-right: 0;
    border: 1px solid rgba(230, 230, 230, 1);
    border-radius: 0;
    background: #f7f8fa;
    height: 39px;
    line-height: 29px;
    font-size: 16px;
    border-bottom: 0;
    border-left: 0;
    color: #969799;
    text-align: center;
    line-height: 39px;
    cursor: pointer;
    &.active {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
      background: #fff;
      height: 40px;
    }
    &:first-child {
      border-left: 1px solid rgba(230, 230, 230, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/payment.vue